import { CyclingEvent } from '@radevents/shared';
import { EventFormValues } from '../components/EventFormModal';
import { priceTierRowsFromTiers } from '../components/PriceTiersEditor';

/**
 * Fuellt das Event-Formular aus einem vorhandenen Event.
 *
 * Liegt im Util und nicht in der Admin-Seite, weil der Veranstalter-Bereich dasselbe Formular
 * benutzt — ein zweiter Aufbau wuerde bei jedem neuen Feld auseinanderlaufen.
 */
export const buildFormFromEvent = (event: CyclingEvent): EventFormValues => ({
  title: event.title,
  description: event.description || '',
  locationName: event.locationName || '',
  street: event.street || '',
  houseNumber: event.houseNumber || '',
  postalCode: event.postalCode,
  city: event.city,
  bundesland: event.bundesland,
  // Permanent: `eventDate` ist nur der Platzhalter 1970 — das Feld bleibt leer, damit
  // beim Abwählen des Häkchens kein 01.01.1970 als Termin dasteht.
  eventDate: event.permanent ? '' : event.eventDate,
  endDate: event.permanent ? '' : event.endDate || '',
  startTime: event.startTime || '',
  startTimeEnd: event.startTimeEnd || '',
  participants: event.participants ? String(event.participants) : '',
  organizer: event.organizer || '',
  organizerId: event.organizerId ?? null,
  category: event.category,
  secondaryCategories: event.secondaryCategories ?? [],
  eventType: event.eventType || '',
  organizerUrl: event.organizerUrl || '',
  // flyerUrlExternal aus demselben Grund wie imageUrlExternal weiter unten.
  flyerUrl: event.flyerUrlExternal || '',
  flyerUploadedUrl: event.flyerUploaded ? (event.flyerUrl ?? null) : null,
  flyerContentType: event.flyerContentType ?? null,
  // imageUrlExternal, nicht imageUrl: letzteres waere bei einem Upload unsere eigene
  // Bild-Route — die wuerde beim Speichern als "externe URL" in die DB zurueckwandern.
  imageUrl: event.imageUrlExternal || '',
  imageCredit: event.imageCredit || '',
  imageAiGenerated: !!event.imageAiGenerated,
  imageFocusX: event.imageFocusX ?? 50,
  imageFocusY: event.imageFocusY ?? 50,
  imageUploadedUrl: event.imageUploaded ? (event.imageUrl ?? null) : null,
  fullyBooked: event.fullyBooked,
  cancelled: event.cancelled,
  tentative: event.tentative,
  permanent: !!event.permanent,
  seasonFrom: event.seasonFrom ?? null,
  seasonUntil: event.seasonUntil ?? null,
  areaName: event.areaName ?? '',
  registrationStart: event.registrationStart || '',
  registrationMode: event.registrationMode ?? 'UNKNOWN',
  registrationState: event.registrationState ?? 'UNKNOWN',
  active: event.active,
  distances: event.distances.length > 0
    ? event.distances.map(d => ({ id: d.id, distanceKm: d.distanceKm, elevationMeters: d.elevationMeters, routeUrl: d.routeUrl || '', label: d.label || '', hasGpx: d.hasGpx, durationMinutes: d.durationMinutes, eventType: d.eventType ?? null, startTime: d.startTime ?? null }))
    : [{ distanceKm: 0, elevationMeters: 0, routeUrl: '', label: '' }],
  komootCollectionUrl: event.komootCollectionUrl || '',
  links: event.links ?? [],
  priceTiers: priceTierRowsFromTiers(event.priceTiers),
});
